export class BipaAccs {
    static getBipaAccountsIds(): any {
        return [
            // BIPA stage env
            { id: "eb945102-4024-11ee-a05f-a13127f73b96", account: "live@bipa.at" },
        ];
    }
}
